export default __webpack_public_path__ + "static/media/EI3-1.e6f5d8d6.jpg";